
export const config = require("../config/config." + window.location.hostname + ".json");//

export default config;